import { useStore } from 'vuex';
import { computed } from 'vue';
import { ACTIVITY_BLOCK_TYPES } from '@/constants/index.js';
import { TestQuizTypes } from '@/components/Blocks/BlockTestOrQuiz/constants.js';
import { useActiveBlock } from '@/hooks/useActiveBlock.js';

// eslint-disable-next-line max-lines-per-function
export const useGlobalPaste = () => {
    const store = useStore();
    const copiedQuestion = computed(() => store.state.AI.copiedQuestions);
    const copiedIncorrectAnswers = computed(() => store.state.AI.copiedIncorrectAnswers);
    const copiedQuotes = computed(() => store.state.AI.copiedQuotes);
    const activeBlock = useActiveBlock();

    /**
     * @param {ClipboardEvent} event
     */
    // eslint-disable-next-line max-statements, max-lines-per-function
    const handlePastePage = event => {
        const isHaveCopiedQuestions = copiedQuestion.value?.length > 0;
        const isHaveCopiedIncorrectAnswer = copiedIncorrectAnswers.value?.length > 0;
        const isHaveCopiedQuotes = copiedQuotes.value?.length > 0;
        const isInsideBlockTestOrQuiz = Boolean(activeBlock.value) &&
            activeBlock.value.type === ACTIVITY_BLOCK_TYPES.TestOrQuiz &&
            activeBlock.value.data.content.type === TestQuizTypes.TEST;
        const isInsideBlockQuotes = Boolean(activeBlock.value) &&
            activeBlock.value.type === ACTIVITY_BLOCK_TYPES.Quote;

        const preventDefault = () => {
            event.preventDefault();
            event.stopPropagation();
        };

        if (isHaveCopiedQuestions || isHaveCopiedIncorrectAnswer || isHaveCopiedQuotes) {
            if (isInsideBlockTestOrQuiz) {
                if (isHaveCopiedQuestions) {
                    preventDefault();
                    store.dispatch('longread/addAiCopiedQuestions', {
                        blockId: activeBlock.value.id,
                        questions: copiedQuestion.value,
                    });
                } else if (isHaveCopiedIncorrectAnswer) {
                    store.dispatch('longread/addAiCopiedIncorrectAnswers', {
                        blockId: activeBlock.value.id,
                        incorrectAnswers: copiedIncorrectAnswers.value,
                        preventDefault,
                    });
                }
            } else if (isInsideBlockQuotes) {
                preventDefault();
                store.dispatch('longread/addAiCopiedQuotes', {
                    blockId: activeBlock.value.id,
                    quotes: copiedQuotes.value,
                });
            }

            store.dispatch('AI/clearCopyQuestions');
            store.dispatch('AI/clearCopyIncorrectAnswers');
            store.dispatch('AI/clearCopyQuotes');
            navigator.clipboard.writeText('');
        }
    };

    document.addEventListener('paste', handlePastePage, { capture: true });
};
